import { configTranslations } from '../app/src/config/translations/configTranslations.js';

start();

async function start() {
  await configTranslations();
  import('./src/view/enrollment');
}
